/** @jsxImportSource @emotion/react */
import "twin.macro";
import { ROUTES } from "./routes";
import slider1 from "../assets/images/slider1.png";
import slider2 from "../assets/images/slider2.png";
import slider3 from "../assets/images/slider3.png";
import slider4 from "../assets/images/slider4.png";
import home from "../assets/svg/NavIcons/compass.svg";
// import vendor from "../assets/svg/NavIcons/calendar.svg";
import registry from "../assets/svg/NavIcons/registry.svg";
import shop from "../assets/svg/NavIcons/shop.svg";
import ourStory from "../assets/svg/NavIcons/heart.svg";
import ourPhotos from "../assets/svg/NavIcons/photos.svg";
import makeNotes from "../assets/svg/NavIcons/document.svg";
import plan from "../assets/svg/NavIcons/plans.svg";
import settings from "../assets/svg/NavIcons/settings.svg";
import invite from "../assets/svg/NavIcons/add_user.svg";
import faq from "../assets/svg/NavIcons/faq.svg";
import rating from "../assets/svg/NavIcons/rating.svg";
import becomeVendor from "../assets/svg/NavIcons/become_vendor.svg";
import planWedding from "../assets/svg/NavIcons/planner.svg";
import greenFlag from "../assets/images/shop/green_flag.png";
import asoebi from "../assets/images/shop/asoebi.png";
import asoebiStock from "../assets/images/shop/asoebi_stock.png";
import edoBead from "../assets/images/shop/edo_bead.png";
import gele from "../assets/images/shop/gele.png";
import shiffon from "../assets/images/shop/shiffon.png";
import reg1 from "../assets/images/reg1.png";
import jumia from "../assets/images/jumia.png";
import bowl from "../assets/images/bowl.png";
import iphone from "../assets/images/iphone.png";
import plate from "../assets/images/plate.png";
import konga from "../assets/svg/konga.png";
import amazon from "../assets/svg/amazon.svg";
import Venues from "../assets/svg/home.svg";
import venHome from "../assets/svg/worldwide.jpeg";
import Food from "../assets/svg/food.svg";
import Band from "../assets/svg/band.svg";
// import cake from "../assets/svg/cake.svg";
// import deco from "../assets/svg/deco.svg";
// import dress from "../assets/svg/dress.svg";
// import planner from "../assets/svg/planner.svg";
// import video from "../assets/svg/video.svg";

export const fallbackImg =
	"data:image/png;base64,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";

export const iconList = [
	{
		name: "General",
		src: venHome,
	},
	{
		name: "Venues",
		src: Venues,
	},
	{
		name: "Food",
		src: Food,
	},
	{
		name: "Band",
		src: Band,
	},
];

export const Images = [
	{
		src: slider1,
		text1: `All your wedding `,
		text2: `experience in one place`,
	},
	{
		src: slider3,
		text1: `Share your wedding`,
		text2: `story with loved ones`,
	},
	{
		src: slider2,
		text1: `Attend a wedding in `,
		text2: `grand style`,
	},
	{
		src: slider4,
		text1: `Connect with top wedding`,
		text2: `vendors around you`,
	},
];

export const coupleSidebar = [
	{
		path: ROUTES.DASHBOARD,
		name: "Home",
		icon: <img src={home} alt="" tw="mr-4" />,
	},

	{
		path: ROUTES.OURSTORY,
		name: "Our Story",
		icon: <img src={ourStory} alt="" tw=" mr-4" />,
	},
	{
		path: ROUTES.OURPHOTOS,
		name: "Our Photos",
		icon: <img src={ourPhotos} alt="" tw=" mr-4" />,
	},
	{
		path: ROUTES.MAKENOTES,
		name: "Make Notes",
		icon: <img src={makeNotes} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.MAKEPLANS,
		name: "Make Plans",
		icon: <img src={plan} alt="" tw="mr-4" />,
	},
	// {
	// 	path: ROUTES.VENDORS,
	// 	name: "Vendors",
	// 	icon: <img src={vendor} alt="" tw=" mr-4" />,
	// 	// children: [{ path: "*/message/drafts*", component: Messages }],
	// },
	{
		path: ROUTES.REGISTRY,
		name: "Registry",
		icon: <img src={registry} alt="" tw=" mr-4" />,
	},
	{
		path: ROUTES.SHOP,
		name: "Shop",
		icon: <img src={shop} alt="" tw=" mr-4" />,
	},

	{
		path: ROUTES.SETTINGS,
		name: "Settings",
		icon: <img src={settings} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.INVITEFRIEND,
		name: "Invite a friend",
		icon: <img src={invite} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.FAQ,
		name: "FAQ",
		icon: <img src={faq} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.RATEUS,
		name: "Rate Us",
		icon: <img src={rating} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.DASHBOARD,
		name: "Join a wedding",
		icon: <img src={becomeVendor} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.SETTINGS,
		name: "Profile",
		icon: <img src={makeNotes} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.PLANWEDDING,
		name: "Plan a wedding (planner)",
		icon: <img src={planWedding} alt="" tw="mr-4" />,
	},
];

export const guestSidebar = [
	{
		path: ROUTES.DASHBOARD,
		name: "Home",
		icon: <img src={home} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.REGISTRY,
		name: "Registry",
		icon: <img src={registry} alt="" tw=" mr-4" />,
	},
	{
		path: ROUTES.SHOP,
		name: "Shop",
		icon: <img src={shop} alt="" tw=" mr-4" />,
	},
	// {
	// 	path: ROUTES.OURSTORY,
	// 	name: "Our Story",
	// 	icon: <img src={ourStory} alt="" tw=" mr-4" />,
	// },
	// {
	// 	path: ROUTES.OURPHOTOS,
	// 	name: "Our Photos",
	// 	icon: <img src={ourPhotos} alt="" tw=" mr-4" />,
	// },
	{
		path: ROUTES.SETTINGS,
		name: "Settings",
		icon: <img src={settings} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.INVITEFRIEND,
		name: "Invite a friend",
		icon: <img src={invite} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.FAQ,
		name: "FAQ",
		icon: <img src={faq} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.RATEUS,
		name: "Rate Us",
		icon: <img src={rating} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.DASHBOARD,
		name: "Create a wedding",
		icon: <img src={plan} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.BECOMEAVENDOR,
		name: "Become a Vendor",
		icon: <img src={becomeVendor} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.REGISTRY,
		name: "Profile",
		icon: <img src={makeNotes} alt="" tw="mr-4" />,
	},
	{
		path: ROUTES.PLANWEDDING,
		name: "Plan a wedding (planner)",
		icon: <img src={planWedding} alt="" tw="mr-4" />,
	},
];

export const photos = [
	{
		src: "https://source.unsplash.com/2ShvY8Lf6l0/800x599",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/Dm-qxdynoEc/800x799",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/qDkso9nvCg0/600x799",
	},
	{
		src: "https://source.unsplash.com/iecJiKe_RNg/600x799",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/epcsn8Ed8kY/600x799",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/NQSWvyVRIJk/800x599",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/zh7GEuORbUw/600x799",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/PpOHJezOalU/800x599",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/I1ASdgphUH4/800x599",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/XiDA78wAZVw/600x799",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/x8xJpClTvR0/800x599",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/u9cG4cuJ6bU/4927x1000",
		width: 4927,
		height: 1000,
	},
	{
		src: "https://source.unsplash.com/qGQNmBE7mYw/800x599",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/NuO6iTBkHxE/800x599",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/pF1ug8ysTtY/600x400",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/A-fubu9QJxE/800x533",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
	{
		src: "https://source.unsplash.com/5P91SF0zNsI/740x494",
		width: Math.floor(Math.random() * 4) + 4,
		height: Math.floor(Math.random() * 4) + 4,
	},
];

export const shopItems = [
	{
		src: greenFlag,
		name: "Groom asoebi",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: asoebi,
		name: "Groom asoebi",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: greenFlag,
		name: "Groom asoebi",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: asoebi,
		name: "Groom asoebi",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: gele,
		name: "Pink gele",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: edoBead,
		name: "Edo bead",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: gele,
		name: "Pink gele",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: edoBead,
		name: "Edo bead",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: shiffon,
		name: "Shiffon",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: asoebiStock,
		name: "Asoebi bulk",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: shiffon,
		name: "Shiffon",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: asoebiStock,
		name: "Asoebi bulk",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: greenFlag,
		name: "Groom asoebi",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: asoebi,
		name: "Groom asoebi",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: greenFlag,
		name: "Groom asoebi",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: asoebi,
		name: "Groom asoebi",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: gele,
		name: "Pink gele",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: edoBead,
		name: "Edo bead",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: gele,
		name: "Pink gele",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: edoBead,
		name: "Edo bead",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: shiffon,
		name: "Shiffon",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: asoebiStock,
		name: "Asoebi bulk",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: shiffon,
		name: "Shiffon",
		price: "N 50,000.00",
		bargain: "50/50",
	},
	{
		src: asoebiStock,
		name: "Asoebi bulk",
		price: "N 50,000.00",
		bargain: "50/50",
	},
];

export const productItems = [
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: reg1,
		name: "Good Grips Complete Grate & Slice Set",
		price: "N 10,000.00",
		gifted: false,
		store: jumia,
	},
	{
		src: bowl,
		name: "Lunea Melamine White Serving Bowl",
		price: "N 1,000.00",
		gifted: true,
		store: jumia,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
	{
		src: iphone,
		name: "iPhone XS MAX 520gb, Silver",
		price: "N 550,000.00",
		gifted: false,
		store: amazon,
	},
	{
		src: plate,
		name: "Nest™ Lock 10-piece Storage Container Set",
		price: "N 5,000.00",
		gifted: false,
		store: konga,
	},
];
